import { graphql, useStaticQuery } from 'gatsby';

export function useFooterTranslation() {
  const { footerTranslation } = useStaticQuery(graphql`
    query {
      footerTranslation {
        data
      }
    }
  `);

  return JSON.parse(footerTranslation.data);
}
